import React, { Component } from 'react';
import {Collapse } from 'react-bootstrap';
import { PieChart, Pie, Cell, Sector } from 'recharts';
import { GroupFilter } from './groupfilter.jsx';
import { SummarySort } from './summarysort.jsx';

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
    fill, payload, percent } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos; // x-start of path line
  const sy = cy + (outerRadius + 10) * sin; // y-start of path line
  const mx = cx + (outerRadius + 30) * cos; // x-mid of path line
  const my = cy + (outerRadius + 30) * sin; // y-mid of path line
  const ex = mx + (cos >= 0 ? 1 : -1) * 22; // x-end of path line
  const ey = my; // y-end of path line
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text x={cx} y={cy} dy={3} textAnchor="middle" fill="#323232">
        { ( payload.name || '' ).trunc(10) }
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
      <text x={ex + (cos >= 0 ? 1 : -1.5) * 35} y={ey + (sin >= 0 ? 1 : -1) * 30} textAnchor={textAnchor} fill="#333">{'مدت: '+payload.duration}</text>
      <text className="percent-label" x={ex + (cos >= 0 ? -1.5 : 0.5) * 30} y={ey + (sin >= 0 ? 1 : -1) * 30} dy={18} textAnchor={textAnchor} fill="#999">
        {` (${(percent * 100).toFixed(2)}% )`}
      </text>
    </g>
  );
};


class Doughnutchart extends Component {
  
  constructor(props){
    super(props);
    this.state = {
      activeIndex: -1,
    }
    this.onPieEnter = this.onPieEnter.bind(this);
  }
  
  onPieEnter(data, index) {
    this.setState({
      activeIndex: index,
    });
  }

  render() {
    let chartData = [{
      color: '#afafaf',
      name: 'سایر',
      value: 0,
      duration: '',
    }];
    let { groupedReport} = this.props;
    let sumS = 0;
    for(let record of groupedReport){
      sumS += record.duration
    }

    for(let record of groupedReport){
      if(record.time < (0.01*sumS)){
        chartData[0].value += record.time;
      }
      else{
        let d = Object.assign({},{
          color: record.color,
          name: record.name,
          value: record.duration,
          duration: record.duration_formatted,
        });
        chartData.push(d);
      }
    }

    chartData[0].duration = (Math.floor(chartData[0].value/3600)) + ':' + (Math.floor((chartData[0].value%3600)/60));
    
    // hanling responsiveness
    let mx = 0.4,my = 0.6;
    if(window.innerWidth < 770) {
      mx = 0.8;
      my = 0.8;
    }
    let containerWidth = window.innerWidth * 0.9 * mx;
    let containerHeight = window.innerHeight * my;
    
    let pieChart = {
      width: containerWidth,
      height: containerHeight,
      xcenter: containerWidth * 0.5,
      ycenter: containerHeight * 0.5
    }

    return (
      <PieChart width={pieChart.width} height={pieChart.height}>
        <Pie
          activeIndex={this.state.activeIndex}
          activeShape={this.state.activeIndex === -1 ? null : renderActiveShape} 
          isAnimationActive={false} 
          label={false}  
          data={chartData} 
          dataKey='value' 
          cx={pieChart.xcenter} 
          cy={pieChart.ycneter} 
          innerRadius={pieChart.height / 8} 
          outerRadius={pieChart.height / 4} 
          onMouseEnter={this.onPieEnter}
          onMouseLeave={()=>this.setState({activeIndex:-1})}
          >
          {
            chartData.map((entry, index) => <Cell key={index} fill={entry.color}/>)
          }
        </Pie >
        { this.state.activeIndex !== -1 ? ('') : ( 
          <text x={pieChart.xcenter} y={pieChart.height / 2} dy={5} dx={5}  textAnchor="middle" fill="#333">
            { this.props.total_sum }
          </text>
        )}
      </PieChart>
    )
  } 
}
  
class Treediagram extends Component {
  constructor(props, context) {
    super(props, context);
    
    this.state = {
      open: [],
    };

    this.handleCollapseClick = this.handleCollapseClick.bind(this);
    this.buildDiagram = this.buildDiagram.bind(this);
    this.getSubtrees = this.getSubtrees.bind(this);
    this.checkAllOpen = this.checkAllOpen.bind(this);
    this.handleAllArrow = this.handleAllArrow.bind(this);
  }

  componentWillReceiveProps(nextProps,nextState) {

    if( this.props.groupedReport.length !== nextProps.groupedReport.length ){
      let temp = [];
      let { groupedReport } = nextProps;
      for(let i =0; i<groupedReport.length; i++) temp.push(false); 
      this.setState({open:temp})
    }

  }

  handleCollapseClick(index) {
    let preOpen = [...this.state.open];
    preOpen[index] = !preOpen[index]
    this.setState({'open':preOpen});
  }

  getSubtrees(index){
    let { groupedReport } = this.props;
    let subtrees = groupedReport[index].list;
    let mappedSbutrees = '';

    mappedSbutrees = subtrees.map((subtree,index)=>(
      <li className="row" key={index}>
        <div className="col col-sm-1" />
        <div className="col col-sm-7" title={subtree.name || ''} >
          <span > { (subtree.name || '' ).trunc(50) } </span>
        </div>
        <div className="col col-sm-1" />
        <div className="col col-sm-3">
          <span > { subtree.duration } </span>
        </div>
      </li>
    )); 
    return mappedSbutrees;
  }

  buildDiagram(){
    let { groupedReport } = this.props;
    let mappedGroups = '';
    
    mappedGroups = groupedReport.map((record,index)=>(
      <div className="row treeBox" key={index} >
        <div className="row main-tree-row"  onClick={this.handleCollapseClick.bind(null,index)} >
          <div className="col col-sm-1">
            <span className={ "glyphicon tree-arrow glyphicon-"+(this.state.open[index] ? 'minus' : 'plus') } > </span>
          </div>
          <div className="col col-sm-7"  > 
            { (record.name || '' ).trunc(30) } 
          </div>
          <div className="col col-sm-1">
            <span className="project-dot" style={{backgroundColor:record.color}}></span>
          </div>
          <div className="col col-sm-3">
            <span className="" > { record.duration_formatted } </span>
          </div>
        </div>

        <Collapse in={this.state.open[index]}>
        <ul className="subtree-container row" >
          {this.getSubtrees(index)}
        </ul>
        </Collapse>
      </div>
    ));

       
    return mappedGroups;
  }

  checkAllOpen() {
    for(let s of this.state.open){
      if(!s) return false;
    }
    return true;
  }

  handleAllArrow() {
    let states = this.state.open;
    let temp = []
    if(this.checkAllOpen()){
      for(let i =0; i<states.length; i++) temp.push(false);
    }
    else{
      for(let i =0; i<states.length; i++) temp.push(true);
    }

    this.setState({open:temp});
  }

  render() {
    
    return (
      <div className="container-fluid">
        <div className="row group-filter-row">
          <div className="all-arrow-container">
            <span onClick={this.handleAllArrow} className={ "glyphicon all-arrow tree-arrow glyphicon-" + (this.checkAllOpen() ? 'minus' : 'plus') } />
          </div>
          <GroupFilter loadingState={this.props.loadingState} groupBy={this.props.groupBy} setGroupBy={this.props.setGroupBy} />
          <SummarySort sortFunc={this.props.sortFunc} suborder={this.props.suborder} loadingState={this.props.loadingState} />
        </div>
        {this.buildDiagram()}
      </div>
       );
  }
}
  
export class Summaryreport extends Component{
    
  componentWillReceiveProps(nextProps,nextState) {
    let allRecordsChanged = JSON.stringify(this.props.records) !== JSON.stringify(nextProps.records) ;
    
    let groupByChanged =  
      ( this.props.groupBy[0].en !== nextProps.groupBy[0].en ) 
      || 
      ( this.props.groupBy[1].en !== nextProps.groupBy[1].en );

    
    let workspaceChanged = false;
    if(!!this.props.ws_id)
      workspaceChanged = this.props.ws_id !== nextProps.ws_id;

    if( workspaceChanged || groupByChanged || allRecordsChanged ){
      this.props.reqReport();
    }

  }
  
  render() {
    return (
      <div>
          <div className="row second-chart-row">
            <div className="col-md-6 col-md-push-3 col-sm-12 doughnut-col">
              <Doughnutchart 
                groupedReport={this.props.groupedReport} 
                total_sum={this.props.total_sum} />
            </div>
            <div className="col-sm-12">
              <Treediagram 
                loadingState={this.props.loadingState} 
                groupBy={this.props.groupBy} 
                setGroupBy={this.props.setGroupBy} 
                sortFunc={this.props.sortFunc} 
                suborder={this.props.suborder}  
                groupedReport={this.props.groupedReport} />
            </div>
          </div>
          <div className="row" style={{minHeight:"300px"}} >
          </div>
      </div>
    )
  }  
}
    
  